import React from 'react';
 
function Element(props) {
    const {children, className, style, propRef,  anyprop, tag, disabled} = props;
    const Tag = `${tag}`;

    return <Tag style={style} className={className} ref={propRef} onClick={anyprop} disabled={disabled}>{children}</Tag>
}
 
export default Element;
